/*
  Ivy Pillow — sticky In winkelwagen-balk: verschijnt rechtsonder zodra de
  echte koopknop boven het scherm uit is gescrold. De knop klikt de echte
  submit aan, zodat Dawn's product-form (AJAX + cart drawer) het werk doet.
*/
(() => {
  function init() {
    const balk = document.querySelector('[data-ivy-sticky-atc]');
    if (!balk || balk.dataset.ivyInit === 'true') return;
    balk.dataset.ivyInit = 'true';

    const echteKnop = document.querySelector('product-form .product-form__submit');
    if (!echteKnop) return;

    const toon = (zichtbaar) => {
      balk.classList.toggle('ivy-sticky-atc--zichtbaar', zichtbaar);
      balk.setAttribute('aria-hidden', zichtbaar ? 'false' : 'true');
    };

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // Alleen tonen wanneer de koopknop boven het scherm uit is
        toon(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      },
      { threshold: 0 }
    );
    io.observe(echteKnop);

    balk.querySelector('[data-sticky-atc-knop]')?.addEventListener('click', () => {
      echteKnop.click();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
